import { Observable } from 'rxjs';

export abstract class ICurrentCodeService {
  abstract getCurrentCode(): Observable<string>;
  abstract setCurrentCode(code: string): void;
}
